"use client";

import { Player, PlayerButton } from "@components/composers/Player";
import { useTranslations } from "next-intl";

import { config } from "./config";
import { captureEvent } from "@/app/_analytics/analytics";
import { EventName } from "@mw/shared/analyticsEventNames";

export default function VoiceCloning() {
  const t = useTranslations("ClientKeys.VoiceCloning");
  return (
    <div className='flex h-full w-full flex-col bg-dark p-4'>
      <div className='flex w-full flex-grow items-center justify-center overflow-y-auto rounded-inxl bg-default px-16 py-8 shadow-xs'>
        <div className='w-full max-w-[600px]'>
          <div className='mb-16 flex items-center md:mb-24'>
            <span className='f-ui-03 ml-16 flex-1 text-lightest'>{t("widget.original")}</span>
            <div className='w-24' />
            <span className='f-ui-03 ml-16 flex-1 text-lightest'>{t("widget.voice_clone")}</span>
          </div>
          {config.map(({ id, name, original, cloned }, idx) => {
            return (
              <div className='mb-16 flex items-center' key={name}>
                <div className='flex-1 rounded-xl border border-default p-6 md:p-12'>
                  <Player
                    audioSrc={original.audio}
                    imgSrc={original.img}
                    name={name}
                    onPlay={() => {
                      captureEvent(EventName.mw_voice_cloning_demo_sample_played, {
                        voice_index: idx,
                        voice_id: id,
                        voice_sample_type: "original",
                        component: "voice_cloning",
                      });
                    }}
                    playerButton={props => <PlayerButton {...props} buttonSize='sm' buttonVariant='primary' />}
                    tags={[{ name: t("widget.original"), className: "bg-default text-lightest p-0" }]}
                  />
                </div>
                <div className='w-8 border-b border-dashed border-default md:w-24' />
                <div className='flex-1 rounded-xl border border-default p-6 md:p-12'>
                  <Player
                    audioSrc={cloned.audio}
                    imgSrc={cloned.img}
                    name={name}
                    onPlay={() => {
                      captureEvent(EventName.mw_voice_cloning_demo_sample_played, {
                        voice_index: idx,
                        voice_id: id,
                        voice_sample_type: "cloned",
                        component: "voice_cloning",
                      });
                    }}
                    playerButton={props => <PlayerButton {...props} buttonSize='sm' buttonVariant='primary' />}
                    tags={[{ name: t("widget.clone"), className: "bg-default text-lightest p-0" }]}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className='px-8 pb-12 pt-16 text-center'>
        <span className='f-ui-03 normal-case'>{t("description")}</span>
      </div>
    </div>
  );
}
